import { CompanyType, PermissionNameUnionType } from '@api';
import {
  TouringCardTable,
  TouringCardTableBody,
  useFilterPermittedItems,
} from '@common';
import { GeneralInformationTableRow } from './components';
import { generalInformationRows } from './data';

type GeneralInformationTablePropsType = {
  company: CompanyType;
};

export const GeneralInformationTable: React.FC<
  GeneralInformationTablePropsType
> = ({ company }) => {
  const { filterPermittedItems } =
    useFilterPermittedItems<PermissionNameUnionType>();

  const rows = filterPermittedItems(generalInformationRows);

  return (
    <TouringCardTable>
      <TouringCardTableBody>
        {rows.map((row) => (
          <GeneralInformationTableRow
            key={row.label}
            company={company}
            row={row}
          />
        ))}
      </TouringCardTableBody>
    </TouringCardTable>
  );
};
